import toPath from 'lodash/toPath';

function vueSetDeep(Vue, obj, field, val) {
  // Normalize path to dot notation
  field = toPath(field).join('.');

  if (field.indexOf('.') === -1) {
    Vue.set(obj, field, val); // maybe hard copy val?
  } else {
    let fields = field.split('.');
    let topLevelField = fields.shift();
    let remainingFields = fields.join('.');
    if (obj[topLevelField] == null) {
      Vue.set(obj, topLevelField, {}); // maybe hard copy val?
    }
    vueSetDeep(Vue, obj[topLevelField], remainingFields, val);
  }
}

export default vueSetDeep;
